import { defaultLocale } from './defaults';
import { Locale, isLocale } from './types';

export default function getLocale(): Locale {
    // get language from localstorage
    const localSetting = localStorage.getItem('cxp-i18n');
    if (localSetting && isLocale(localSetting)) {
        return localSetting;
    }

    // get language from browser
    const [browserSetting] = navigator.language.split('-');
    if (isLocale(browserSetting)) {
        return browserSetting;
    }

    return defaultLocale;
}
